import { ProductTypeEnum } from '../../../product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON_BARRIER_BREAK,
  PAYOFF_COUPON_BARRIER_LOWER_LEVEL,
  PAYOFF_COUPON_BARRIER_UPPER_LEVEL,
  PAYOFF_COUPON_CAP,
  PAYOFF_COUPON_CONDITIONAL_RATE,
  PAYOFF_COUPON_CONDITIONAL_STRIKE,
  PAYOFF_COUPON_CONVERSION,
  PAYOFF_COUPON_COUPON_CALCULATION_DAYS,
  PAYOFF_COUPON_DIGITAL_AMOUNT,
  PAYOFF_COUPON_DIGITAL_STRIKE,
  PAYOFF_COUPON_FLOATING_PERIODS,
  PAYOFF_COUPON_FLOOR,
  PAYOFF_COUPON_LOWER_BARRIER_STEP_SIZE,
  PAYOFF_COUPON_MEMORY,
  PAYOFF_COUPON_MULTIPLIER,
  PAYOFF_COUPON_PERFORMANCE_CALCULATION,
  PAYOFF_COUPON_RANGE_ACCRUAL_RATE,
  PAYOFF_COUPON_RATE_INTERPOLATION,
  PAYOFF_COUPON_RATE_RESET,
  PAYOFF_COUPON_REFERENCE_RATE,
  PAYOFF_COUPON_SPREAD,
  PAYOFF_COUPON_STRIKE,
  PAYOFF_COUPON_SUSPENSION_LENGTH,
  PAYOFF_COUPON_TYPE,
  PAYOFF_COUPON_UPPER_BARRIER_STEP_SIZE,
  PAYOFF_PARTICIPATION,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
} from '../../mockups/consts/product-capture-field-selectors.consts';

export const RANGE_ACCRUAL_DEFAULTS = [
  {
    formControlNames: [
      PAYOFF_COUPON_PERFORMANCE_CALCULATION,
      PAYOFF_COUPON_REFERENCE_RATE,
      PAYOFF_COUPON_MULTIPLIER,
      PAYOFF_COUPON_STRIKE,
      PAYOFF_COUPON_SPREAD,
      PAYOFF_COUPON_FLOOR,
      PAYOFF_COUPON_CAP,
      PAYOFF_COUPON_DIGITAL_STRIKE,
      PAYOFF_COUPON_DIGITAL_AMOUNT,
      PAYOFF_COUPON_RATE_RESET,
      PAYOFF_COUPON_RATE_INTERPOLATION,
      PAYOFF_COUPON_CONVERSION,
      PAYOFF_COUPON_FLOATING_PERIODS,
      PAYOFF_COUPON_MEMORY,
      PAYOFF_COUPON_BARRIER_UPPER_LEVEL,
      PAYOFF_COUPON_UPPER_BARRIER_STEP_SIZE,
      PAYOFF_COUPON_BARRIER_LOWER_LEVEL,
      PAYOFF_COUPON_LOWER_BARRIER_STEP_SIZE,
      PAYOFF_COUPON_CONDITIONAL_RATE,
      PAYOFF_COUPON_CONDITIONAL_STRIKE,
      SUMMARY_REFERENCE_ENTITIES,
    ],
    hidden: true,
  },
  {
    formControlNames: [PAYOFF_COUPON_SUSPENSION_LENGTH],
    selectValues: [1],
    hidden: false,
    readOnly: false,
  },
  {
    formControlNames: [PAYOFF_COUPON_RANGE_ACCRUAL_RATE],
    selectValues: [
      {
        minValue: null,
        maxValue: null,
        value: null,
        indicativeValue: null,
      },
    ],
    hidden: false,
  },
  {
    formControlNames: [PAYOFF_COUPON_BARRIER_BREAK],
    selectValues: ['BACK_IN_FOR_PERIOD'],
    hidden: false,
    readOnly: true,
  },
  {
    formControlNames: [PAYOFF_COUPON_COUPON_CALCULATION_DAYS],
    selectValues: ['CALENDAR_DAYS'],
    hidden: false,
  },
  {
    formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
    selectValues: ['NONE'],
    readOnly: false,
  },
  { 
    formControlNames: [PAYOFF_PARTICIPATION],
    hidden: true
  }
];

export const RANGE_ACCRUAL_SETTINGS = {
  id: ProductTypeEnum.RANGE_ACCRUAL,
  label: 'Range Accrual',
  effects: [
    {
      formControlNames: [PAYOFF_COUPON_TYPE],
      selectValues: ['RANGE_ACCRUAL'],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION],
      hidden: true,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE],
      selectValues: ['FIXED'],
      hidden: false,
      readOnly: true,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: '100%',
          indicativeValue: null,
        },
      ],
      hidden: false,
      readOnly: true,
    },
  ],
};
